import { gql, useQuery } from "@apollo/client";
import UserMasterListFilterParams from "../interfaces/filters/UserMasterListFilterParams"

export function useUserSettings() {
  return useQuery(
    gql`
      query getUserSettings {
        me {
          nudge_delay
          nudge_interaction
          nudge_no_interaction_start
          is_onboarded
        }
      }
    `
  );
}

export function useUserSettingsWithOrganisation() {
  return useQuery(
    gql`
      query getUserSettingsWithOrganisation {
        me {
          nudge_delay
          nudge_interaction
          nudge_no_interaction_start
          organisation {
            nudge_delay
            nudge_interaction
            nudge_no_interaction_start
            allow_user_customisation
          }
        }
      }
    `
  );
}

export function useUserPaginated(filter : UserMasterListFilterParams) {
  return useQuery(
    gql`
      query getUserPaginated($page : Int!, $limit : Int!, $organisation : String, $search : String ) {
        users_paginated(page : $page, limit : $limit, organisation : $organisation, search : $search ) {
          total_pages
          page 
          docs {
            _id
            organisation_id {
              _id
              name
            }
            first_name
            last_name
            name
            email
            licenses
            blocked
            date_allocated
            expiry_date
            az_id
          }
        }
      }
    `,
    {
      variables : {
        page : filter.page,
        limit : filter.limit,
        organisation : filter.organisation,
        search : filter.search.trim()
      }
    }
  );
}


